<script lang="ts">
export default {
    name: 'SidebarSettings',
};
</script>

<script setup lang="ts">
import i18n from '@/plugins/i18n';
import SidebarSection from '@/components/app/sidebar/section/section.vue';

const emit = defineEmits({
    navigate: null,
});
</script>

<template>
    <sidebar-section
        name="settings"
        route="userSettings"
        :label="i18n.t('user.settings.title')"
        :icon="{
            name: 'sliders',
            prefix: 'fas',
        }"
        @navigate="emit('navigate')"
    />
</template>
